module.exports = __webpack_public_path__ + "ece662aeaa54de797c604628c5857c18.png";